import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import styles from './NotFound.module.css';

/**
 * NotFound — 404 as a Windows XP Blue Screen of Death.
 * Any key press, click, or tap returns to the homepage.
 */
const NotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const goHome = (e) => {
      // Let keyboard users Tab around and use shortcuts without being yanked home
      if (e.key === 'Tab' || e.metaKey || e.ctrlKey || e.altKey) return;
      if (['Shift', 'Control', 'Alt', 'Meta'].includes(e.key)) return;
      navigate('/');
    };
    window.addEventListener('keydown', goHome);
    return () => window.removeEventListener('keydown', goHome);
  }, [navigate]);

  return (
    <main
      className={styles.bsod}
      onClick={() => navigate('/')}
      aria-label="Page not found. Press any key or tap to return to the homepage."
    >
      <Helmet>
        <title>Page Not Found | The Boombox Miami</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className={styles.inner}>
        <p>
          A problem has been detected and BOOMBOX has been shut down to prevent
          damage to your night out.
        </p>

        <p className={styles.stopName}>PAGE_NOT_FOUND_EXCEPTION</p>

        <p>
          If this is the first time you&apos;ve seen this Stop error screen,
          double-check the URL. If this screen appears again, follow these
          steps:
        </p>

        <p>
          * Head back to the homepage and start over.
          <br />
          * The party is probably somewhere else tonight — check the upcoming
          events.
        </p>

        <p>Technical information:</p>

        <p className={styles.stopCode}>
          *** STOP: 0x00000404 (0xB00MB0X, 0x4447SW75, 0x0000M1A, 0xFL33155)
        </p>

        <p className={styles.prompt}>
          Press any key (or tap) to return to the venue
          <span className={styles.cursor} aria-hidden="true">_</span>
        </p>
      </div>
    </main>
  );
};

export default NotFound;
